import axios from 'axios';
import { Storage } from 'react-jhipster';

import { FAILURE, REQUEST, SUCCESS } from 'app/shared/reducers/action-type.util';
import { setLocale } from 'app/shared/reducers/locale';
import { isAccountCompleted } from 'app/shared/util/account-utils';
import { IMe } from '../model/user.model';
import { getWallets } from './account-wallets';

export const ACTION_TYPES = {
  LOGIN: 'authentication/LOGIN',
  GET_SESSION: 'authentication/GET_SESSION',
  LOGOUT: 'authentication/LOGOUT',
  CLEAR_AUTH: 'authentication/CLEAR_AUTH',
  ERROR_MESSAGE: 'authentication/ERROR_MESSAGE',
};

// const AUTH_TOKEN_KEY = 'jhi-authenticationToken';

const initialState = {
  loading: false,
  isAuthenticated: false,
  loginSuccess: false,
  loginError: false, // Errors returned from server side
  me: {} as IMe,
  loginErrorMessage: null as any,
  errorMessage: (null as unknown) as string, // Errors returned from server side
  redirectMessage: (null as unknown) as string,
  sessionHasBeenFetched: false,
  idToken: (null as unknown) as string,
  logoutUrl: (null as unknown) as string,
  isAccountCompleted: false,
};

export type AuthenticationState = Readonly<typeof initialState>;

// Reducer

export default (state: AuthenticationState = initialState, action): AuthenticationState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.LOGIN):
    case REQUEST(ACTION_TYPES.GET_SESSION):
      return {
        ...state,
        loading: true,
      };
    case FAILURE(ACTION_TYPES.LOGIN):
      return {
        ...initialState,
        loginErrorMessage: action.payload.response.data.detail,
        loginError: true,
      };
    case FAILURE(ACTION_TYPES.GET_SESSION):
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        sessionHasBeenFetched: true,
        errorMessage: action.payload,
      };

    case SUCCESS(ACTION_TYPES.LOGIN):
      return {
        ...state,
        loading: false,
        loginError: false,
        loginSuccess: true,
      };
    case ACTION_TYPES.LOGOUT: {
      return initialState;
    }
    case SUCCESS(ACTION_TYPES.GET_SESSION): {
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        sessionHasBeenFetched: true,
        me: action.payload.data,
        isAccountCompleted: isAccountCompleted(action.payload.data),
      };
    }
    case ACTION_TYPES.ERROR_MESSAGE:
      return {
        ...initialState,
        redirectMessage: action.message,
      };
    case ACTION_TYPES.CLEAR_AUTH:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
      };

    default:
      return state;
  }
};

export const displayAuthError = message => ({ type: ACTION_TYPES.ERROR_MESSAGE, message });

export const getSession: () => void = () => async (dispatch, getState) => {
  await dispatch({
    type: ACTION_TYPES.GET_SESSION,
    payload: axios.get('api/me'),
  });

  const { account } = getState().authentication;
  if (account && account.langKey) {
    const langKey = Storage.session.get('locale', account.langKey);
    await dispatch(setLocale(langKey));
  }

  if (account) {
    // TODO: only if ROLE_USER
    await dispatch(getWallets(account.login));
  }
};

export const login: (username: string, password: string, rememberMe?: boolean) => void = (
  username,
  password,
  rememberMe = false
) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.LOGIN,
    payload: axios.post('api/me/authenticate', { username, password, rememberMe }),
  });

  if (result?.value?.status === 200) {
    await dispatch(getSession());
  }

  // const bearerToken = result.value.headers.authorization;
  // if (bearerToken && bearerToken.slice(0, 7) === 'Bearer ') {
  //   const jwt = bearerToken.slice(7, bearerToken.length);
  //   if (rememberMe) {
  //     Storage.local.set(AUTH_TOKEN_KEY, jwt);
  //   } else {
  //     Storage.session.set(AUTH_TOKEN_KEY, jwt);
  //   }
  // }
};

// export const clearAuthToken = () => {
//   if (Storage.local.get(AUTH_TOKEN_KEY)) {
//     Storage.local.remove(AUTH_TOKEN_KEY);
//   }
//   if (Storage.session.get(AUTH_TOKEN_KEY)) {
//     Storage.session.remove(AUTH_TOKEN_KEY);
//   }
// };

export const logout: () => void = () => async dispatch => {
  // clearAuthToken();
  dispatch({
    type: ACTION_TYPES.LOGOUT,
    dispatch: await axios.post('api/me/logout'),
  });
  window.location.href = '/';
};

export const clearAuthentication = messageKey => (dispatch, getState) => {
  // clearAuthToken();
  // dispatch(displayAuthError(messageKey));
  dispatch({
    type: ACTION_TYPES.CLEAR_AUTH,
  });
};
